import { Platform } from 'react-native';

import { APP_STORE_URL } from '@/constants/gifting';

const APP_SCHEME_URL = 'marketprycerewards://season-of-gifting';
const FALLBACK_DELAY_MS = 1600;

/**
 * One button, two outcomes (web only): try the app's custom scheme — if the
 * app is installed, iOS foregrounds it and this page hides; if nothing
 * claims the scheme within the delay AND we're still visible, fall through
 * to the App Store. The visibility guard is what prevents the ugly
 * both-happen case: app opens, then Safari also navigates to the store
 * behind it.
 *
 * Same defensive shape as isIosWeb: web-only globals are treated as absent
 * by default (Hermes/prerender), evaluated at call time, never module scope.
 */
export function openAppOrStore(): void {
  if (Platform.OS !== 'web') return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  let opened = false;
  const markOpened = () => {
    opened = true;
  };
  document.addEventListener('visibilitychange', markOpened);
  window.addEventListener('pagehide', markOpened);

  window.location.href = APP_SCHEME_URL;

  setTimeout(() => {
    document.removeEventListener('visibilitychange', markOpened);
    window.removeEventListener('pagehide', markOpened);
    if (!opened && document.visibilityState === 'visible') {
      window.location.href = APP_STORE_URL;
    }
  }, FALLBACK_DELAY_MS);
}
